 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ACOVER from '@/components/1-cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import ATITLE_PAGE from '@/components/2-title_page'
 import ATOC from '@/components/3-TOC'
 import ASTART from '@/components/4-start'
 import AEPIGRAPH from '@/components/5-epigraph'
 import ACHAP1 from '@/components/6-chap1'
 import ACHAP2 from '@/components/7-chap2'
 import ACHAP3 from '@/components/8-chap3'
 import ACHAP4 from '@/components/9-chap4'
 import A0CHAP5 from '@/components/10-chap5'
 import A1CHAP6 from '@/components/11-chap6'
 import A2CHAP7 from '@/components/12-chap7'
 import A3CHAP8 from '@/components/13-chap8'
 import A4CHAP9 from '@/components/14-chap9'
 import A5CHAP10 from '@/components/15-chap10'
 import A6CHAP11 from '@/components/16-chap11'
 import A7CHAP12 from '@/components/17-chap12'
 import A8CHAP13 from '@/components/18-chap13'
 import A9CHAP14 from '@/components/19-chap14'
 import A0CHAP15 from '@/components/20-chap15'
 import A1CHAP16 from '@/components/21-chap16'
 import A2CHAP17 from '@/components/22-chap17'
 import A3CHAP18 from '@/components/23-chap18'
 import A4CHAP19 from '@/components/24-chap19'
 import A5CHAP20 from '@/components/25-chap20'
 import A6CHAP21 from '@/components/26-chap21'
 import A7CHAP22 from '@/components/27-chap22'
 import LOVE_2 from '@/components/love_2'
 import A8BIOGRAPHY from '@/components/28-biography'
 import A9BIO1 from '@/components/29-bio1'
 import A0BIO2 from '@/components/30-bio2'
 import A1BIO3 from '@/components/31-bio3'
 import A2BIO4 from '@/components/32-bio4'
 import A3BIO5 from '@/components/33-bio5'
 import A4BIO6 from '@/components/34-bio6'
 import A5BIO7 from '@/components/35-bio7'
 import A6BIO8 from '@/components/36-bio8'
 import A7BIO9 from '@/components/37-bio9'
 import A8BIO10 from '@/components/38-bio10'
 import A9BIO11 from '@/components/39-bio11'
 import A0BIO12 from '@/components/40-bio12'
 import A1COPYRIGHT from '@/components/41-copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/3-TOC",
 			"name" : "3-TOC",
 			"component" : ATOC
 		},
 		{
 			"path" : "/4-start",
 			"name" : "4-start",
 			"component" : ASTART
 		},
 		{
 			"path" : "/5-epigraph",
 			"name" : "5-epigraph",
 			"component" : AEPIGRAPH
 		},
 		{
 			"path" : "/6-chap1",
 			"name" : "6-chap1",
 			"component" : ACHAP1
 		},
 		{
 			"path" : "/7-chap2",
 			"name" : "7-chap2",
 			"component" : ACHAP2
 		},
 		{
 			"path" : "/8-chap3",
 			"name" : "8-chap3",
 			"component" : ACHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js